<template>
    <f-fullscreen-modal ref="modal">
        <f-app-screen>
            <f-modal-header @close="$refs.modal.close()">{{ $t('privacy.policy') }}</f-modal-header>
            <iframe
                    src="https://forexhero.eu/privacy-policy"
                    class="w-full grow "
            ></iframe>
        </f-app-screen>
    </f-fullscreen-modal>
</template>

<script>
import Analytics, { SCREEN_VIEW_POLICY } from '/src/services/Analytics'

export default {
  name: 'PrivacyPolicyModal',
  methods: {
    open () {
      Analytics.setScreenName(SCREEN_VIEW_POLICY)
      this.$refs.modal.open()
    }
  }
}
</script>
